module.exports = __webpack_public_path__ + "img/rhopalosiphum-padi.9617003e.jpg";